import React, { useRef, useState, useCallback, useEffect } from "react";
import Webcam from "react-webcam";
import { Modal } from "react-bootstrap"; 
import { IoClose } from "react-icons/io5";
import "./CustomModal.css";
import { Button } from "react-bootstrap";

const CameraModal = ({ show, handleClose, setPhotoInBox }) => {
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const imageSectionRef = useRef(null); 
  const [capturedImage, setCapturedImage] = useState(null);
  const [frameImgSrc, setFrameImgSrc] = useState(null);
  const [isWebcamReady, setIsWebcamReady] = useState(false);
  const [isFrameLoaded, setIsFrameLoaded] = useState(false);
  const [useFrontCamera, setUseFrontCamera] = useState(true); 
  const [videoConstraints, setVideoConstraints] = useState({
    facingMode: useFrontCamera ? "user" : "environment",
  });

  const [frameSides, setFrameSides] = useState("LH");

  useEffect(() => {
    const defaultFrameUrl = frameSides === "LH" 
      ? "./frame_with_transparency.png"
      : "./frame_with_transparency_mirror.png";
    setFrameImgSrc(defaultFrameUrl);
    setIsFrameLoaded(true);
  }, [frameSides]);

  const handleUserMedia = () => {
    setIsWebcamReady(true);
  };

  const captureWithFrame = useCallback(() => {
    const video = webcamRef.current.video;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    if (isWebcamReady && isFrameLoaded && video.readyState === 4) {
      // Ensure the canvas matches the video feed dimensions
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;
      canvas.width = videoWidth;
      canvas.height = videoHeight;

      // Draw the camera feed on the canvas
      context.drawImage(video, 0, 0, videoWidth, videoHeight);

      // Draw the default PNG frame on top (with transparency)
      const img = new Image();
      img.crossOrigin = "anonymous"; 
      img.src = frameImgSrc;
      img.onload = () => {
        context.drawImage(img, 0, 0, videoWidth, videoHeight);

        // Get the final image from the canvas
        const imageSrc = canvas.toDataURL("image/jpeg");
        setCapturedImage(imageSrc); 
        setPhotoInBox(imageSrc); 
        handleClose(); 
      };
    } else {
      console.log("Webcam or frame image not ready yet.");
    }
  }, [isWebcamReady, isFrameLoaded, frameImgSrc, handleClose, setPhotoInBox]);

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Update video constraints and canvas size based on image-section size
  useEffect(() => {
    if (imageSectionRef.current) {
      const { offsetWidth, offsetHeight } = imageSectionRef.current;

      // Set video constraints and canvas size to match the image section
      setVideoConstraints({
        width: offsetWidth,
        height: offsetHeight,
        facingMode: useFrontCamera ? "user" : "environment",
      });

      if (canvasRef.current) {
        canvasRef.current.width = offsetWidth;
        canvasRef.current.height = offsetHeight;
      }
    }
  }, [width, height, useFrontCamera]);

  return (
    <Modal
      onHide={handleClose}
      size="lg"
      show={show}
      id="success_tic"      
      className="card-radius
       popup-modal-dark  
       add_club_modal 
       build_sheet_modal camera_modal modal-camera-open 
       "
    >
      <Modal.Body className="p-0"
        dialogClassName="custom-modal "
      >
        <div className="close-modal">
          <div className="custom-modal-header">
                      <h3 className="text d-flex mb-0"><span class="color">1</span> &nbsp; Capture Image</h3>  

            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
             
            >
              <IoClose />
            </button>
          </div>
        </div>

        <div ref={imageSectionRef} className="image-section">
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={videoConstraints}
            style={{
              width: videoConstraints.width,
              height: videoConstraints.height,
            }}
            onUserMedia={handleUserMedia}
          />

          {frameImgSrc && (
            <img
              src={frameImgSrc}
              alt="Frame"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: videoConstraints.width,
                height: videoConstraints.height,
              }}
            />
          )}

          <canvas
            ref={canvasRef}
            style={{ display: "none" }}
          />
        </div>

        <div className="button-section">
          <div className="switch-custom">
            <Button
              className={frameSides === "LH" ? "switch-active" : ""}
              variant="outline-dark"
              onClick={() => setFrameSides("LH")}
            >
              LH
            </Button>
            <Button
              variant="outline-dark"
              className={frameSides === "RH" ? "switch-active" : ""}
              onClick={() => setFrameSides("RH")}
            >
              RH
            </Button>
          </div>
          <Button
            variant="success"
            className="take-photo-btn"
            onClick={captureWithFrame}
          >
            Take Photo
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CameraModal;